import React, { useEffect, useState } from 'react'
import DashboardStyle from '../Dashboard'
import { customFuncsApi } from '../../../api'
import { Empty, Input } from 'antd'
import { useTranslation } from 'react-i18next'
import ClipLoader from 'react-spinners/ClipLoader'
import Button from '../../../components/Button'
import { formatNumber } from '../../../utils/formatNumber'
import { debouncedSearch } from '../../../utils/debounce'

const PAGE_SIZE = 20

const money = (v) => {
	if (v == null || v === '') return ''
	const n = Number(v)
	return Number.isNaN(n) ? v : formatNumber(n)
}
const pct = (v) => (v == null || v === '' ? '' : v)
const text = (v) => (v == null || v === '' ? '' : v)

export default function Tab6() {
	const { t } = useTranslation()

	const [isLoading, setIsLoading] = useState(false)

	// All filters start empty — no defaults per spec.
	const [date1, setDate1] = useState('')
	const [date2, setDate2] = useState('')

	const [cardCode, setCardCode] = useState('')
	const [cardCodeInput, setCardCodeInput] = useState('')

	const [rows, setRows] = useState([])
	const [count, setCount] = useState(0)
	const [page, setPage] = useState(0)

	const fetchReport = (d1, d2, cc, currentPage) => {
		setIsLoading(true)

		// date1/date2 must be sent together or not at all.
		const datesPaired = d1 && d2

		const params = {
			pageSize: PAGE_SIZE,
			$skip: currentPage * PAGE_SIZE,
		}
		if (datesPaired) {
			params.date1 = d1
			params.date2 = d2
		}
		if (cc) params.CardCode = cc

		customFuncsApi
			.get('rassrochkaReport', {
				params,
				headers: {
					Prefer: `odata.maxpagesize=${PAGE_SIZE}`,
				},
			})
			.then((res) => {
				setRows(res.data?.value || [])
				setCount(Number(res.data?.count || 0))
			})
			.finally(() => {
				setIsLoading(false)
			})
	}

	useEffect(() => {
		setPage(0)
	}, [date1, date2, cardCode])

	useEffect(() => {
		fetchReport(date1, date2, cardCode, page)
	}, [date1, date2, cardCode, page])

	const onCardCodeChange = (e) => {
		const v = e.target.value
		setCardCodeInput(v)
		debouncedSearch(v, setCardCode)
	}

	const totalPages = Math.max(1, Math.ceil((count || 0) / PAGE_SIZE))

	const newPage = () => {
		if (rows.length < PAGE_SIZE || page + 1 >= totalPages) {
			alert(t('noOtherInfo'))
		} else {
			setPage((p) => p + 1)
		}
	}

	const oldPage = () => {
		if (page > 0) {
			setPage((p) => p - 1)
		} else {
			alert(t('noOtherInfo'))
		}
	}

	const columns = [
		{
			title: t('invoices'),
			dataIndex: 'Invoice savdo',
			render: (v) => text(v),
		},
		{
			title: t('clientName'),
			dataIndex: 'Klient',
			render: (v) => text(v),
		},
		{
			title: t('clientCode'),
			dataIndex: 'Klient raqami',
			render: (v) => text(v),
		},
		{
			title: 'Tovar nomi',
			dataIndex: 'Tovar nomi',
			render: (v) => text(v),
		},
		{
			title: t('serialNum'),
			dataIndex: 'Tovar seriyasi',
			render: (v) => text(v),
		},
		{
			title: 'Ранги',
			dataIndex: 'Rangi',
			render: (v) => text(v),
		},
		{
			title: 'Сотув нарх',
			dataIndex: 'Sotuv Narx',
			render: (v) => money(v),
		},
		{
			title: 'Фойда',
			dataIndex: 'Foyda',
			render: (v) => money(v),
		},
		{
			title: t('monthlyPayment'),
			dataIndex: "Oylik to'lov",
			render: (v) => money(v),
		},
		{
			title: 'Таннарх',
			dataIndex: 'Tannarx',
			render: (v) => money(v),
		},
		{
			title: 'Аванс',
			dataIndex: 'Avans',
			render: (v) => money(v),
		},
		{
			title: 'Ойлик фойда',
			dataIndex: 'Oylik foyda',
			render: (v) => money(v),
		},
		{
			title: 'Қолдиқ + фойда',
			dataIndex: 'Foyda bilan qoldiq',
			render: (v) => money(v),
		},
		{
			title: 'Таннарх (авансдан кейин)',
			dataIndex: 'Tannarx avansdan keyin',
			render: (v) => money(v),
		},
		{
			title: 'Маржа %',
			dataIndex: 'Marja %',
			render: (v) => pct(v),
		},
		{
			title: 'Маржа % yillik',
			dataIndex: 'Marja % yillik',
			render: (v) => pct(v),
		},
		{
			title: 'Наценка %',
			dataIndex: 'Natsenka %',
			render: (v) => pct(v),
		},
		{
			title: 'Наценка % yillik',
			dataIndex: 'Natsenka % yillik',
			render: (v) => pct(v),
		},
	]

	return (
		<DashboardStyle>
			<div className="container minWidthContainer">
				<h4 className={'font-bold text-lg text-center mt-10 mb-4'}>
					{t('rassrochkaReports')}
				</h4>

				<div className="mb-4 flex items-end gap-10 justify-end flex-wrap">
					<div className="flex flex-col gap-2">
						<span>{t('clientCode')}</span>
						<Input
							allowClear
							placeholder={t('clientCode')}
							value={cardCodeInput}
							onChange={onCardCodeChange}
						/>
					</div>
					<div className="flex flex-col gap-2">
						<span>{t('startDate')}</span>
						<Input
							type="date"
							value={date1}
							onChange={(e) => setDate1(e.target.value)}
						/>
					</div>
					<div className="flex flex-col gap-2">
						<span>{t('endDate')}</span>
						<Input
							type="date"
							value={date2}
							onChange={(e) => setDate2(e.target.value)}
						/>
					</div>
				</div>

				{isLoading ? (
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<ClipLoader
							loading={true}
							size={20}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					</div>
				) : (
					<div className="overflow-auto mb-8 max-h-[70vh] relative">
						<table className="w-full text-sm text-left rtl:text-right text-gray-500">
							<thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0 z-10">
								<tr>
									{columns.map((col) => (
										<th
											key={col.dataIndex}
											scope="col"
											className="px-6 py-4 bg-gray-50 whitespace-nowrap"
										>
											{col.title}
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								{rows.length > 0 ? (
									rows.map((row, i) => (
										<tr
											key={row['Invoice savdo'] ?? i}
											className="bg-white border-b hover:bg-gray-50"
										>
											{columns.map((col) => (
												<td
													key={col.dataIndex}
													className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap tabular-nums"
												>
													{col.render(row[col.dataIndex], row, i)}
												</td>
											))}
										</tr>
									))
								) : (
									<tr>
										<td colSpan={columns.length}>
											<Empty
												description={t('noInfo')}
												image={Empty.PRESENTED_IMAGE_SIMPLE}
											/>
										</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				)}

				<div className="flex items-center gap-2 mt-4">
					<Button className={'btn'} onClick={oldPage}>
						{'<'}
					</Button>
					<span>
						{page + 1}
						{count ? ` / ${totalPages}` : ''}
					</span>
					<Button className={'btn'} onClick={newPage}>
						{'>'}
					</Button>
				</div>
			</div>
		</DashboardStyle>
	)
}
